import { render, staticRenderFns } from "./editLogoImageDialog.vue?vue&type=template&id=80b60b42&"
import script from "./editLogoImageDialog.vue?vue&type=script&lang=js&"
export * from "./editLogoImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./editLogoImageDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports